import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fba78cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-auto mb-5 bg-red-5" }
const _hoisted_2 = { class: "w-full h-5 bg-red-20 text-sm mt-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { class: "my-4 font-bold text-lg justify-between flex bg-yellow-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "w-full h-auto flex flex-wrap" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "w-full flex justify-center mt-2"
}
const _hoisted_17 = {
  key: 1,
  class: "hidden"
}
const _hoisted_18 = {
  key: 2,
  class: "overflow-hidden"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-4 font-bold text-lg flex text-def" }, " 필터 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttributeFilter = _resolveComponent("AttributeFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentStatus === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 분양 새 글"))
        : (_ctx.currentStatus === 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToReptile && _ctx.goToReptile(...args)))
            }, _toDisplayString(`종 > ${_ctx.selectedSpecies} > 전체보기`), 1))
          : (_ctx.selectedKeyword !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 검색결과"))
            : (_ctx.selectedSpecies !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(`종 > ${_ctx.findCategory(_ctx.selectedSpecies)} > ${_ctx.selectedSpecies}`), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "분양 새 글"))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.currentStatus === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 새로 올라온 친구들"))
        : (_ctx.currentStatus === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.selectedSpecies), 1))
          : (_ctx.selectedKeyword !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(`'${_ctx.selectedKeyword}'(으)로 검색한 결과`), 1))
            : (_ctx.selectedSpecies !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 모프"))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, "새로 올라온 친구들"))
    ]),
    (_ctx.selectedSpecies && _ctx.morphList.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slicingMorphList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["py-1 px-2 rounded-full bg-[#f2f4f5] mr-3 mb-3 text-sm text-def", _ctx.morphToggle[index] ? 'isActive' : null]),
                  onClick: ($event: any) => (_ctx.handleToggle(index))
                }, _toDisplayString(item), 11, _hoisted_15)
              ]))
            }), 128))
          ]),
          (_ctx.slicingMorphList.length !== _ctx.morphList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "px-4 py-[2px] bg-white text-[13px] font-medium rounded-full ring-1 ring-zinc-200",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMorphList && _ctx.handleMorphList(...args)))
                }, "전체보기")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedKeyword !== null || _ctx.currentStatus === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_AttributeFilter)
        ]))
  ]))
}